const BaseUrl = import.meta.env.VITE_API_URL

/** GET /api/drivers — optional ?store_id= for store-scoped lists */
export const driversListUrl = (storeId) => {
    const base = BaseUrl + "/api/drivers";
    if (storeId === undefined || storeId === null || storeId === "") return base;
    return `${base}?store_id=${encodeURIComponent(String(storeId))}`;
};

/** GET /api/warehouse — optional ?store_id= for store-scoped lists (super admin) */
export const warehousesListUrl = (storeId) => {
    const base = BaseUrl + "/api/warehouse";
    if (storeId === undefined || storeId === null || storeId === "") return base;
    return `${base}?store_id=${encodeURIComponent(String(storeId))}`;
};

export const ApiConfig = {
    URL: BaseUrl,
    LOGIN: BaseUrl + "/api/login",
    FORGOT_PASSWORD_REQUEST: BaseUrl + "/api/forgot-password/request",
    FORGOT_PASSWORD_RESET: BaseUrl + "/api/forgot-password/reset",
    LOGOUT: BaseUrl + "/api/logout",
    UPLOAD_ITEMS: BaseUrl + "/api/media",
    ADD_DRIVER: BaseUrl + "/api/driver/register",
    DRIVER: BaseUrl + "/api/drivers",
    WAREHOUSE: BaseUrl + "/api/warehouse",
    SHIPMENTS: BaseUrl + "/api/shipments",
    SHOPIFY_BACKED: BaseUrl + "/shopify-backend",
    ORDERS: BaseUrl + "/api/orders",
    ORDERS_CREATE: BaseUrl + "/api/orders/create",
    ORDERS_UPDATE_STATUS: BaseUrl + "/api/orders", // PUT /api/orders/:id/delivery-status
    APP_CONFIG: BaseUrl + "/api/appConfig",
    STORES: BaseUrl + "/api/stores",
    STORE_ONBOARDING: BaseUrl + "/api/store/onboarding",
    Orders: BaseUrl + "/api/admin-Dashboard",
    getallOrderByStoreId: BaseUrl + "/api/getallOrderByStoreId",


    // old 
    UPLOAD: BaseUrl + "/api/media",
    ALL_USERS: BaseUrl + "/api/users",
    USERS: BaseUrl + "/api/users",
    CATEGORIES: BaseUrl + "/api/categorie",
    ADMIN_CATEGORIES: BaseUrl + "/api/AdminCategorie",
    BLOCK_USER: BaseUrl + "/api/userBlock",
    PLAY_LIST: BaseUrl + "/api/playlists",
    GET_PLAYLIST: BaseUrl + "/api/playlist/",
    PLAYLIST: BaseUrl + "/api/AdminPlaylists/",
    PLAYLIST_ADD_CATEGORIES: BaseUrl + "/api/playlistAddCategories",
    PLAYLIST_Delete_CATEGORIES: BaseUrl + "/api/deletePlaylistCategories",
    PLAYLISTS_IDS: BaseUrl + "/api/getAryPlaylist",
    PLAYLISTS_IDS: BaseUrl + "/api/getAryPlaylist",
    ADMIN_ITEM: BaseUrl + "/api/AdminItemUpdate",
    PAYMENT: BaseUrl + "/api/payments",
    APP_CONFIG: BaseUrl + "/api/appConfig",
    ALL_PURCHASE_POINT: BaseUrl + "/api/getAllPurchasePointAdmin",
    SHORT_CATEGORIES: BaseUrl + "/api/CategorisSort",
    SEND_ADMIN_MESSAGE: BaseUrl + "/api/sendMessageAdmin",

    // Custom Notifications (DB-backed)
    CUSTOM_NOTIFICATIONS: BaseUrl + "/api/customNotifications",

    // Store API Keys
    STORE_API_KEYS: BaseUrl + "/api/storeApiKeys",
    STORE_API_KEYS_MY_STORE: BaseUrl + "/api/storeApiKeys/my-store",

    // Staff
    STAFF: BaseUrl + "/api/staff",

    // Plans - base: /api/plans
    PLANS: BaseUrl + "/api/plans",
    PLANS_ACTIVE: BaseUrl + "/api/plans/active",
    PLANS_CHECK: BaseUrl + "/api/plans/check",           // ?storeId= required
    PLANS_ASSIGN: BaseUrl + "/api/plans/assign",        // body: { storeId, planId, endDate?, skipPayment? }
    PLANS_PAYMENT_CONFIG: BaseUrl + "/api/plans/payment/config",
    PLANS_PAYMENT_CREATE_ORDER: BaseUrl + "/api/plans/payment/create-order",
    PLANS_PAYMENT_VERIFY: BaseUrl + "/api/plans/payment/verify",
    PLANS_STORE: BaseUrl + "/api/plans/store",          // /:storeId, /:storeId/usage, /:storeId/history, /:storeId/invoices
    PLANS_RENEW: BaseUrl + "/api/plans/renew",          // body: { chargeId }
    PLANS_RENEWALS_UPCOMING: BaseUrl + "/api/plans/renewals/upcoming",

    // Test API
    TEST_SIGNATURE: BaseUrl + "/api/test",

    // Support Tickets
    SUPPORT_TICKETS: BaseUrl + "/api/support/tickets",
};